export default "__VITE_ASSET__bef9b08b__"